import SignIn from './SignIn.vue';

export default {
  install(Vue) {
    Vue.component('SignIn', SignIn);
    Vue.mixin({
      methods: {
        showSignIn() {
          this.$root.$emit('show-sign-in');
          return new Promise((resolve, reject) => {
            this.$root.$on('resolve-sign-in', (signedIn) => {
              if (signedIn) {
                resolve(signedIn);
              } else {
                reject(signedIn);
              }
              this.$root.$off('resolve-sign-in');
            });
          });
        },
        showSignUp() {
          this.$root.$emit('show-sign-up');
          return new Promise((resolve, reject) => {
            this.$root.$on('resolve-sign-up', (signedUp) => {
              if (signedUp) {
                resolve(signedUp);
              } else {
                reject(signedUp);
              }
              this.$root.$off('resolve-sign-up');
            });
          });
        },
      },
    });
  },
};
